import { render, staticRenderFns } from "./inventoryReportDetail.vue?vue&type=template&id=1ee8ce77&"
import script from "./inventoryReportDetail.vue?vue&type=script&lang=ts&"
export * from "./inventoryReportDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports